import { useState, useEffect } from "react";
import styles from "./PaymentMethod.module.scss";
import { useTranslation } from "react-i18next";
import OptionsGroup from "./OptionsGroup";
import _ from "lodash";
import { ReactComponent as FPSLogo } from "../assets/fps_color.svg";
import FPSLogoo from "../assets/fps.jpeg"
import PayMeLogo from "../assets/payme-logo-red.png";
import CashLogo from "../assets/payAtSite.png";
import StripeLogo from "../assets/stripe.png";

const PaymentMethod = ({ paymentItmeProps, xc }) => {
  const { t } = useTranslation();
  return (
    <div className={`${styles["payment-div"]} ${xc}`}>
      <PayAtSitePaymentItem {...paymentItmeProps} />
      <PayMePaymentItem {...paymentItmeProps} />
      <StripePaymentItem {...paymentItmeProps} />
      <HSBCPaymentItem {...paymentItmeProps} />
      {/* {window.location.pathname == "/donation" ? (
        <h5>
          注：信用咭公司會在你的捐款中扣除 2.9%(本地)至3.4%(外地) 及PayMe會在你的捐款中扣除 1.5%
          作為他們的行政費用。你或可考慮選擇其他捐款途徑，以讓我們全數收悉你的善款，感恩！
        </h5>
      ) : (
        <h5>
          注：信用咭公司會在你的付款中扣除 2.9%(本地)至3.4%(外地) 及PayMe會在你的付款中扣除 1.5%
          作為他們的行政費用。你或可考慮選擇其他付款途徑，以讓我們全數收悉你的善款，感恩！
        </h5>
      )} */}
    </div>
  );
};

const PayAtSitePaymentItem = ({ paymentMethod, setPaymentMethod }) => {
  const label = "PAY at SITE";
  const classes = paymentMethod === label ? "selected" : "";

  return (
    <div className={`${styles["payment-item"]} ${classes}`} onClick={() => setPaymentMethod(label)}>
      <div style={{ width: "30%" }}>
        <img src={CashLogo} width={65} className="centerImage" />
      </div>
      <p>{label}</p>
    </div>
  );
};

const PayMePaymentItem = ({ paymentMethod, setPaymentMethod }) => {
  const label = "PayMe";
  const classes = paymentMethod === label ? "selected" : "";

  return (
    <div className={`${styles["payment-item"]} ${classes}`} onClick={() => setPaymentMethod(label)}>
      <div style={{ width: "50%", marginTop: 10 }}>
        <img src={PayMeLogo} />
      </div>
      <p>{label}</p>
    </div>
  );
};

const StripePaymentItem = ({ paymentMethod, setPaymentMethod }) => {
  const label = "Card";
  const classes = paymentMethod === label ? "selected" : "";

  return (
    <div className={`${styles["payment-item"]} ${classes}`} onClick={() => setPaymentMethod(label)}>
      <div style={{ width: "50%", marginTop: 10 }}>
        <img src={StripeLogo} width={120} className="centerImage" />
      </div>
      <p>{label}</p>
    </div>
  );
};

const FPSPaymentItem = ({ paymentMethod, setPaymentMethod }) => {
  const label = "FPS";
  const classes = paymentMethod === label ? "selected" : "";

  return (
    <div className={`${styles["payment-item"]} ${classes}`} onClick={() => setPaymentMethod(label)}>
      <div style={{ width: "50%", marginTop: 10 }}>
        <img src={FPSLogo} width={120} className="centerImage" />
      </div>
      <p>{label}</p>
    </div>
  );
};

const HSBCPaymentItem = ({ paymentMethod, setPaymentMethod }) => {
  const label = "FPS";
  const classes = paymentMethod === label ? "selected" : "";

  return (
    <div className={`${styles["payment-item"]} ${classes}`} onClick={() => setPaymentMethod(label)}>
      <div>
        <FPSLogo />
      </div>
      <p>{label}</p>
    </div>
  );
};

export default PaymentMethod;
